import React from "react";

export default function NotificationSettings() {
  return (
    <div className="content">
      {/* Page Header */}
      <div className="mb-3 border-bottom pb-3">
        <h4 className="fw-bold mb-0">Settings</h4>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row">
            {/* Right Section */}
            <div className="col-lg-12">
              <div className="border-1 border-start ps-4">
                <h5 className="fw-bold pb-3 mb-4 border-1 border-bottom">
                  Notifications
                </h5>

                {/* ----- ITEM CARD REUSABLE ----- */}
                {[
                  {
                    icon: "ti ti-calendar-time",
                    title: "New Appointment Booking",
                    desc: "Alert when an appointment is booked",
                  },
                  {
                    icon: "ti ti-calendar-x",
                    title: "Appointment Cancellation",
                    desc: "Alert if an appointment is cancelled",
                  },
                  {
                    icon: "ti ti-calendar-time",
                    title: "Lab Report Ready",
                    desc: "Notify when test reports are available",
                  },
                  {
                    icon: "ti ti-activity-heartbeat",
                    title: "Follow-up Reminders",
                    desc: "Scheduled follow-ups from doctors",
                  },
                  {
                    icon: "ti ti-file-dollar",
                    title: "Billing/Invoice Notification",
                    desc: "Notify when a new bill or invoice is generated",
                  },
                  {
                    icon: "ti ti-alert-octagon",
                    title: "System Alerts",
                    desc: "Login attempts, data changes, or system updates.",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center justify-content-between flex-wrap row-gap-3 border mb-3 p-3 rounded"
                  >
                    <div className="d-flex align-items-center">
                      <span className="avatar avatar-lg border bg-light me-2">
                        <i className={`${item.icon} text-body fs-16`}></i>
                      </span>
                      <div>
                        <h5 className="fs-14 fw-semibold mb-1">{item.title}</h5>
                        <p className="fs-13">{item.desc}</p>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-4">
                      {["Email", "SMS", "In App"].map((label, i) => (
                        <div key={i}>
                          <p className="fw-medium mb-1 text-dark">{label}</p>
                          <label className="d-flex align-items-center form-switch ps-0">
                            <input
                              className="form-check-input m-0"
                              type="checkbox"
                              defaultChecked
                            />
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
